import { serializeQuery, type QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteria } from '../model/types';
import { checkInDateRange } from './toUrl/checkInDateRange';
import { hotelCategories } from './toUrl/hotelCategories';
import { hotels } from './toUrl/hotels';
import { meals } from './toUrl/meals';
import { nightRange } from './toUrl/nightRange';
import { resorts } from './toUrl/resorts';
import { toCountry } from './toUrl/toCountry';
import { touristGroup } from './toUrl/touristGroup';

/**
 * Query-string для поиска отельных офферов (порт
 * `components/hotelOffersSearch/router/toRouter.js`). Нет `fromCity` — в отельных
 * офферах город вылета отсутствует.
 */
export function getHotelOffersUrl(criteria: SearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({
    ...toCountry(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotelCategories(criteria),
    ...meals(criteria),
    ...hotels(criteria),
    ...otherCriteria,
  });
}
